module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2MDAiIGhlaWdodD0iNDAwIiB2aWV3Qm94PSIwIDAgMTUgMTAiPjxwYXRoIGZpbGw9IiM2YWIyZTciIGQ9Ik0wIDBoMTV2MTBIMHoiLz48cGF0aCBmaWxsPSIjMTJhZDJiIiBkPSJNMCA1aDE1djVIMHoiLz48cGF0aCBkPSJNMCAwdjEwbDQuMzMtMi41TDguNjYgNSA0LjMzIDIuNSAwIDB6IiBmaWxsPSIjZmZmIi8+PHBhdGggZD0iTTMuMzE0IDMuNzVsLjMxLjk1NUg0LjYzbC0uODEzLjU5LjMxLjk1NS0uODEyLS41OS0uODEyLjU5LjMxLS45NTVMMiA0LjcwNWgxLjAwNGwuMzEtLjk1NXoiIGZpbGw9IiNkNzE0MWEiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/dji.svg
// module id = j3Vi
// module chunks = 0